<template>
  <div class="chart">
    <div class="heaer-text">自定义报表</div>
    <div style="overflow: hidden">
      <allreport-filter
        ref="filterRef"
        @handleSearch="handleSearch"
        @downloadFile="downloadFile"
      ></allreport-filter>
    </div>
    <div class="table-wrap">
      <allreport-table
        ref="tableRef"
        @closeDownLoadLoading="closeDownLoadLoading"
        @openModal="openModal"
      ></allreport-table>
    </div>
    <el-dialog :title="titleModal" :visible.sync="dialogVisible" width="1200px">
      <ChartsModal :dataList="dataList"></ChartsModal>
    </el-dialog>
  </div>
</template>

<script>
import AllreportFilter from "./allreportFilter";
import AllreportTable from "./allreportTable";
import ChartsModal from "./chartsModal.vue";
export default {
  name: "allreportbak",
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      titleModal: "",
    };
  },
  computed: {},
  components: {
    AllreportFilter,
    AllreportTable,
    ChartsModal,
  },
  mounted() {},
  methods: {
    handleSearch(value) {
      this.$refs.tableRef?.handleSearch(value);
    },
    downloadFile() {
      this.$refs.tableRef.downLoadFileToExcel();
    },
    closeDownLoadLoading() {
      this.$refs.filterRef.closeDownLoadLoading();
    },
    openModal(data, row) {
      this.dataList = data;
      this.titleModal = row.appName;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 0px 15px;
}
.el-dialog__body {
  padding: 0px;
}
</style>
